"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const runEvent_1 = require("../../../app/dist/runEvent");
const reorderSteps_1 = require("../../../app/dist/reorderSteps");
const planUlid_1 = require("./planUlid");
exports.toolDef = {
    name: 'loom_reorder_steps',
    description: 'Reorder a plan\'s steps. Pass orderedStepIds as the full set of the plan\'s step ids in the new order (a permutation — no adds/drops). blockedBy references survive (they point at ids). Done/cancelled steps must stay the leading block in their original order — only pending work reorders. Use this tool to reorder steps — do not edit plan files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            plan_ulid: { type: 'string', description: 'Plan\'s stable pl_ ULID (e.g. "pl_01J…"). ULID only — a filename stem or title is rejected.' },
            orderedStepIds: { type: 'array', items: { type: 'string' }, description: 'Every step id of the plan, in the desired new order.' },
        },
        required: ['plan_ulid', 'orderedStepIds'],
    },
};
async function handle(root, args) {
    const planUlid = (0, planUlid_1.requirePlanUlid)(args);
    const orderedStepIds = args['orderedStepIds'] ?? [];
    const loadWeaveStrict = async (r, w) => {
        const result = await (0, dist_1.loadWeave)(r, w);
        if (!result)
            throw new Error(`Weave not found: ${w}`);
        return result;
    };
    const deps = {
        loadWeave: loadWeaveStrict,
        runEvent: (weaveSlug, event) => (0, runEvent_1.runEvent)(weaveSlug, event, { loadWeave: loadWeaveStrict, saveDocs: dist_1.saveDocs, loomRoot: root }),
        loomRoot: root,
    };
    const result = await (0, reorderSteps_1.reorderSteps)({ planUlid, orderedStepIds }, deps);
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
